import API from "./API";
import { logCaptureMessage } from "../utils/sentryLogger";

/**
 * Add product to Shopify cart
 * @param {object} data - Shopify order object
 */
export function addProductToCart(productsData) {
    let products = [...productsData.productsToAdd];
    let attrs = {
        attributes: {
            deliveryDate: productsData.deliveryDate,
            dietType: productsData.dietType,
        },
    };

    const chainedCall = () => {
        if (products.length) {
            let request = products.shift(),
                data = {};
            if (typeof request.skuList !== "undefined" && typeof request.mealTitles !== "undefined" && typeof request.handles !== "undefined") {
                data = {
                    id: request.id,
                    quantity: request.quantity,
                    properties: {
                        _SKUs: request.skuList,
                        _includes: request.mealTitles,
                        _handles: request.handles,
                        _exclude_codes: request.excludeCodes,
                        _fresh_lean: request.freshLean,
                    },
                };
            } else if (
                typeof request.skuList !== "undefined" &&
                typeof request.mealTitles === "undefined" &&
                typeof request.handles === "undefined"
            ) {
                data = {
                    id: request.id,
                    quantity: request.quantity,
                    properties: {
                        _SKUs: request.skuList,
                    },
                };
            } else {
                data = {
                    id: request.id,
                    quantity: request.quantity,
                    properties: {
                        _shipping_interval_frequency: "1",
                        _shipping_interval_unit_type: "Weeks"
                    },
                };
            }
            if (request.selling_plan !== null) {
                data.selling_plan = request.selling_plan;
            } else {
                data.properties._shipping_interval_frequency = "1";
                data.properties._shipping_interval_unit_type = "Weeks";
            }

            if (["39990491021430","39992546066550", "40055267885174", "40055267950710", "44899639853355", "44799040749867", "44799042224427", "45049912197419", "40073304899702", "40073304965238", "47306732568875", "45179358216491", "45179487486251", "40272716333174"].includes(request.id)) {
                data.properties._shipping_interval_frequency = "6";
                data.properties._shipping_interval_unit_type = "Weeks";
            }

            if (process.env.NODE_ENV === "production") {
                API.post("/cart/add.js", JSON.stringify(data))
                    .then((_response) => {
                        chainedCall();
                    })
                    .catch(function (_error) {
                        logCaptureMessage("Axios catch error of /cart/add.js post");
                    });
            } else {
                console.log(data);
                chainedCall();
            }
        } else {
            if (process.env.NODE_ENV === "production") {
                API.post("/cart/update.js", JSON.stringify(attrs))
                    .then(() => {
                        window.location.href = "/cart";
                    })
                    .catch(function (error) {
                        logCaptureMessage("Axios catch error of /cart/update.js post");
                        console.log("Axios catch", error);
                    });
            } else {
                console.log("/cart/update.js", attrs);
            }
        }
    };
    chainedCall();
}

/**
 * Clear Shopify cart request
 * @param {function} func - callback function after Cart clear
 */
export function clearCart(func) {
    if (process.env.NODE_ENV === "production") {
        API.post("/cart/clear.js")
            .then(() => {
                func();
            })
            .catch(function (error) {
                console.log("Axios catch", error);
            });
    } else {
        func();
    }
}
